import { useTranslation } from '@thoughtspot/i18n';
import { ExplainerCard } from '@thoughtspot/radiant-react/widgets/explainer-card';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Popover } from '@thoughtspot/radiant-react/widgets/popover';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { getName, getURL } from "../../../../utils/dependents";
import styles from './dependent-objects.module.scss';
const renderItemWithLink = (item) => (React.createElement(Horizontal, { key: item.id, className: styles.deleteList, spacing: "a" },
    React.createElement(Typography, { variant: "content-label-subhead", wrapContent: true },
        React.createElement(Link, { "data-testid": `connectionLinkId${item.id}`, href: getURL(item) }, item.name)),
    React.createElement(Typography, { variant: "p", color: Colors.base },
        "(",
        getName(item),
        ")")));
const parseData = (logicalData) => {
    return logicalData.map((item) => {
        return renderItemWithLink({
            ...item,
            subType: item.subType,
            type: item.type,
        });
    });
};
export const DependentsModal = ({ isModalOpen, onModalClose, logicalData, title, warningDescription, deletionInstructions, }) => {
    const { t } = useTranslation();
    const onModalDismissBtnClick = () => {
        onModalClose();
    };
    return (React.createElement(Modal, { size: ModalSize.SMALL, title: title, isOpen: isModalOpen, confirmButton: {
            text: t('CLOSE'),
            onConfirm: onModalDismissBtnClick,
        }, modalTestId: "dependents-modal-test-id" },
        React.createElement(Vertical, { className: styles.modalContainer },
            warningDescription,
            React.createElement(Vertical, { className: styles.listContainer }, parseData(logicalData)),
            deletionInstructions)));
};
export const DependentPopover = ({ targetRef, isVisible, setIsVisible, logicalData, }) => {
    const { t } = useTranslation();
    const popoverContent = (React.createElement(ExplainerCard, { onCrossClick: () => setIsVisible(false), media: React.createElement(Vertical, { className: styles.listContainer },
            React.createElement(Typography, { variant: "body-normal" }, t('customRegion.file.update.dependancy.explainer.card.description')),
            parseData(logicalData)), title: t('customRegion.file.update.dependancy.explainer.card.title') }));
    return (React.createElement(Popover, { targetRef: targetRef, isVisible: isVisible, content: popoverContent, align: "bottom" }));
};
//# sourceMappingURL=index.js.map